module.exports = __webpack_public_path__ + "media/img/sbt-test/Scholarships2u-result-badge-6c354268762638eb124c31321251793c.svg";